import service from "@/plugins/request";

/**
 * 提现操作
 * @param {*} data
 * @returns
 */
export function apiBackendWithdraw(data) {
  return service({
    url: "/v1/protected/user/reward/backend/withdraw/action",
    method: "post",
    data
  });
}

/**
 * 赞赏列表
 * @param {*} params
 * @returns
 */
export function apiBackendRewardList(params) {
  return service({
    url: "/v1/protected/user/reward/backend/order/page-list",
    method: "get",
    params
  });
}

/**
 * 提现列表
 * @param {*} params
 * @returns
 */
export function apiBackendWithdrawList(params) {
  return service({
    url: "/v1/protected/user/reward/backend/withdraw/page-list",
    method: "get",
    params
  });
}

/**
 * 生成支付订单
 * @param {*} data
 * @returns
 */
export function apiRewardOrder(data) {
  return service({
    url: "/v1/protected/user/reward/order",
    method: "post",
    data
  });
}

/**
 * 支付订单
 * @param {*} data
 * @returns
 */
export function apiOrderPay(data) {
  return service({
    url: "/v1/protected/user/reward/pay",
    method: "post",
    data
  });
}

/**
 * 获取订单状态
 * @param {*} params
 * @returns
 */
export function apiOrderDetail(params) {
  return service({
    url: "/v1/user/reward/getOrderPreDetailByCode",
    method: "get",
    params
  });
}

/**
 * 赞赏gamekee
 * @param {*} data
 * @returns
 */
export function apiRewardGamekee(data) {
  return service({
    url: "/v1/protected/user/reward/gamekee",
    method: "post",
    data
  });
}

/**
 * 发起提现
 * @param {*} data
 * @returns
 */
export function apiRewardWithdraw(data) {
  return service({
    url: "/v1/protected/user/reward/withdraw",
    method: "post",
    data
  });
}

/**
 * 提现账户配置
 * @param {*} data
 * @returns
 */
export function apiWithdrawConfig(data) {
  return service({
    url: "/v1/protected/user/reward/set-withdraw-config",
    method: "post",
    data
  });
}

/**
 * 个人中心概览
 * @param {*} params
 * @returns
 */
export function apiMinePreview(params) {
  return service({
    url: "/v1/protected/user/reward/info",
    method: "get",
    params
  });
}

/**
 * 赞赏列表
 * @param {*} params
 * @returns
 */
export function apiRewardList(params) {
  return service({
    url: "/v1/protected/user/reward/page-list",
    method: "get",
    params
  });
}

/**
 * 收益列表
 * @param {*} params
 * @returns
 */
export function apiIncomeList(params) {
  return service({
    url: "/v1/protected/user/reward/revenue/page-list",
    method: "get",
    params
  });
}

/**
 * 提现列表
 * @param {*} params
 * @returns
 */
export function apiWithdrawList(params) {
  return service({
    url: "/v1/protected/user/reward/withdraw/page-list",
    method: "get",
    params
  });
}

/**
 * 根据订单号获取订单支付状态
 * @param {*} params
 * @returns
 */
export function apiOrderStateByCode(params) {
  return service({
    url: "/v1/user/reward/queryOrderStateByCode",
    method: "get",
    params
  });
}

/**
 * 获取游戏/文章的赞赏信息
 * @param {*} params
 * @returns
 */
export function apiRewardInfo(params) {
  return service({
    url: "/v1/user/reward/query-people",
    method: "get",
    params
  });
}
